import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";

const useInOfficePatientDetails = () => {
  const dispatch = useDispatch();
  const { accounts } = useSelector((state) => state.account);
  const { inOfficeUploadPatientDetails } = useSelector(
    (state) => state.manualUpload
  );
  const {
    inOfficeData: { patientDeviceInformation },
  } = inOfficeUploadPatientDetails || {};

  const hasAccessToAccountInNoteFile =
    patientDeviceInformation.hasAccessToAccountInNoteFile;

  const [invalidAccountName, setInvalidAccountName] = useState();
  const [updatedAccountName, setUpdatedAccountName] = useState();

  useEffect(() => {
    setInvalidAccountName(patientDeviceInformation?.clinic);
  }, [hasAccessToAccountInNoteFile]);

  const accountList = accounts.map(({ name }) => {
    return { value: name, label: name };
  });

  return {
    dispatch,
    setUpdatedAccountName,

    accountList,
    updatedAccountName,
    invalidAccountName,
    hasAccessToAccountInNoteFile,
    patientDeviceInformation,
    inOfficeUploadPatientDetails,
  };
};

export default useInOfficePatientDetails;
